import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Button, DatePicker, Dropdown, Menu, Modal, Typography } from 'antd'
import QueueAnim from 'rc-queue-anim'
import enquire from 'enquire.js'

import moment from 'moment'

import { DESKTOP_DOWN } from '../../config/mediaQueries'

import { generalActions } from './../../redux/actions'

import { closingCalculationPeriodService } from './../../redux/services'

import { UIPageListing } from './../../components'

import ModalShow from './show'
import ModalFilters from './filters'
import ModalCreate from './create'

const config = {
  title: 'Fechamento do Período de Cálculo',
  subtitle: 'Visualize e gerencie os períodos de cálculo fechados.',
  icon: <i className="fal fa-calendar-check" />,
  infoBanner: {
    icon: <i className="fal fa-info-circle" />,
    title: 'Importante',
    description: 'Os dias dentro de um período fechado não são recalculados. Para recalcular, reabra o fechamento.',
  },
  permissionPrefix: 'fechamento-periodo-calculo',
  list: 'fechamento-periodo-calculo',
  orders: [
    {
      label: 'Data (Mais recentes)',
      field: 'data_inicio',
      sort: 'desc',
      default: true,
    },
    {
      label: 'Data (Mais antigos)',
      field: 'data_inicio',
      sort: 'asc',
    },
    {
      label: 'Cadastro (Mais recentes)',
      field: 'id',
      sort: 'desc',
    },
    {
      label: 'Cadastro (Mais antigos)',
      field: 'id',
      sort: 'asc',
    },
  ],
}

class Index extends Component {
  constructor(props) {
    super(props)

    const defaultOrder = config.orders.find((o) => o.default)

    this.state = {
      isLoading: false,
      listType: 'list',
      data: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      orderByLabel: defaultOrder.label,
      orderByField: defaultOrder.field,
      orderBySort: defaultOrder.sort,
      // Actions
      createModalVisible: false,
      filtersModalVisible: false,
      showModalVisible: false,
      activeLoadings: [],
      // Media queries
      desktopDown: false,
      // Filters
      filters: {
        empresa: null,
        departamento: null,
        funcionario: null,
      },
      periodo: null,
      kpis: null,
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.listType && state.listType !== props.listType) {
      return {
        listType: props.listType,
      }
    }

    return null
  }

  componentDidMount() {
    // Fetch all
    this.fetchGetAll(true)

    // Listen Media Query sideBar
    enquire.register(DESKTOP_DOWN, {
      match: () => {
        this.setState({
          desktopDown: true,
        })
      },
      unmatch: () => {
        this.setState({
          desktopDown: false,
        })
      },
    })
  }

  componentWillUnmount() {
    // Unlisten Media Query sideBar
    enquire.unregister(DESKTOP_DOWN)
  }

  menuItem = (item) => (
    <Menu className="actions-dropdown-menu">
      {this.props.permissions.includes(config.permissionPrefix + ".show") &&      
        <Menu.Item key="show">
          <a onClick={() => this.showOpen(item)}>
            <i className="fal fa-file" />
            Visualizar
          </a>
        </Menu.Item>
      }
      {this.props.permissions.includes(config.permissionPrefix + ".delete") &&      
        <Menu.Item key="delete" className="divider btn-delete">
          <a onClick={() => this.deleteConfirm(item)}>
            <i className="fas fa-undo" />
            Reabrir
          </a>
        </Menu.Item>
      }
    </Menu>
  )

  renderNames = (items, emptyLabel) => {
    const names = (items ?? []).map((item) => item.nome).join(', ')

    return names ? <Typography.Text ellipsis={{ tooltip: names }}>{names}</Typography.Text> : emptyLabel
  }

  columns = () => {
    const listTypeCard = this.state.listType === 'card'
    return [
      {
        title: 'Data início',
        className: 'datetime card-block-width-2',
        render: (item) => {
          if (listTypeCard) {
            return (
              <Fragment>
                <i className="fal fa-calendar-alt" style={{ marginRight: 5 }} />
                {moment(item.data_inicio).format('DD/MM/YYYY')}
              </Fragment>
            )
          }

          return moment(item.data_inicio).format('DD/MM/YYYY')
        },
      },
      {
        title: 'Data fim',
        className: 'datetime card-block-width-2',
        render: (item) => {
          if (listTypeCard) {
            return (
              <Fragment>
                <i className="fal fa-calendar-check" style={{ marginRight: 5 }} />
                {moment(item.data_fim).format('DD/MM/YYYY')}
              </Fragment>
            )
          }

          return moment(item.data_fim).format('DD/MM/YYYY')
        },
      },
      {
        title: 'Empresa',
        render: (item) => this.renderNames(item.empresas, 'Todas'),
      },
      {
        title: 'Departamento',
        render: (item) => this.renderNames(item.departamentos, 'Todos'),
      },
      {
        title: 'Funcionário',
        render: (item) => this.renderNames(item.funcionarios, 'Todos'),
      },
      {
        title: 'Data do cadastro',
        className: 'datetime card-block-width-2',
        render: (item) => {
          if (listTypeCard) {
            return (
              <Fragment>
                <i className="fal fa-plus-circle" style={{ marginRight: 5 }} />
                {moment(item.created_at).format('DD/MM/YYYY')}
              </Fragment>
            )
          }

          return moment(item.created_at).format('DD/MM/YYYY')
        },
      },
      {
        title: 'Ações',
        className: 'actions no-ellipsis',
        visible: this.props.permissions.includes(config.permissionPrefix + ".show") || this.props.permissions.includes(config.permissionPrefix + ".delete"),
        render: (item) => (
          <Dropdown
            overlay={this.menuItem(item)}
            className="actions-dropdown"
            placement="bottomRight"
            trigger={['click']}
          >
            <Button icon={<i className="fal fa-ellipsis-v" />} />
          </Dropdown>
        ),
      },
    ]
  }

  fetchGetAll = (init = false) => {
    const { pagination, orderByField, orderBySort, filters, periodo } =
      this.state

    this.setState({
      isLoading: true,
    })

    const data = {
      orderBy: `${orderByField}:${orderBySort}`,
    }

    data.page = init ? 1 : pagination.current
    data.limit = pagination.pageSize

    if (filters.empresa !== null) {
			data.empresa = filters.empresa;
		}

    if (filters.departamento !== null) {
			data.departamento = filters.departamento;
		}

    if (filters.funcionario !== null) {
			data.funcionario = filters.funcionario;
		}

    if (periodo?.[0]) {
      data.data_inicio = periodo[0].format('YYYY-MM-DD')
    }

    if (periodo?.[1]) {
      data.data_fim = periodo[1].format('YYYY-MM-DD')
    }

    closingCalculationPeriodService
      .getAll(data)
      .then((response) => {
        this.setState((state) => ({
          isLoading: false,
          data: response.data.data,
          kpis: response.data.kpis ?? null,
          pagination: {
            ...state.pagination,
            current: response.data.meta.current_page,
            total: response.data.meta.total,
          },
        }))
      })
      .catch((data) => {
        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  onPeriodoChange = (periodo) => {
    this.setState({ periodo }, () => this.fetchGetAll(true))
  }

  kpis = () => {
    const { kpis, periodo } = this.state
    const caption = periodo ? 'No período selecionado' : 'Nos registros listados'
    const ultimo = kpis?.ultimo_fechamento
    let ultimoCaption = caption

    if (ultimo) {
      if (ultimo.todas_empresas || !ultimo.empresas.length) {
        ultimoCaption = 'Todas as empresas'
      } else if (ultimo.empresas.length === 1) {
        ultimoCaption = ultimo.empresas[0]
      } else {
        ultimoCaption = `${ultimo.empresas.length} empresas`
      }
    }

    return [
      {
        key: 'periodos',
        tone: 'blue',
        icon: <i className="fal fa-calendar-alt" />,
        title: 'Períodos fechados',
        value: kpis?.registros ?? null,
        caption,
      },
      {
        key: 'empresas',
        tone: 'green',
        icon: <i className="fal fa-building" />,
        title: 'Empresas',
        value: kpis?.empresas ?? null,
        caption,
      },
      {
        key: 'funcionarios',
        tone: 'amber',
        icon: <i className="fal fa-users" />,
        title: 'Funcionários',
        value: kpis?.funcionarios ?? null,
        caption,
      },
      {
        key: 'ultimo',
        tone: 'violet',
        icon: <i className="fal fa-check-circle" />,
        title: 'Último fechamento',
        value: ultimo ? moment(ultimo.data_fim).format('DD/MM/YYYY') : null,
        caption: ultimoCaption,
      },
    ]
  }

  onListTypeChange = (type) => {
    this.props.onChangeListType(type)
  }

  onPaginationChange = (page, pageSize) => {
    this.setState(
      (state) => ({
        pagination: {
          ...state.pagination,
          current: page,
          pageSize,
        },
      }),
      () => {
        this.fetchGetAll()
      }
    )
  }

  onOrderChange = (value) => {
    const defaultOrder = config.orders.find(
      (o) => `${o.field}:${o.sort}` === value
    )

    if (!defaultOrder) return null

    this.setState(
      (state) => ({
        orderByLabel: defaultOrder.label,
        orderByField: defaultOrder.field,
        orderBySort: defaultOrder.sort,
      }),
      () => {
        this.fetchGetAll(true)
      }
    )
  }

  /**
   * Show
   *
   * @param uuid
   */
  showOpen = ({ uuid }, general_key) => {
    this.setState({ showModalVisible: true })

    // On open screen
    this.showScreen.onOpen(uuid, general_key)
  }

  showOnClose = () => {
    this.setState({ showModalVisible: false })
  }

  /**
   * Delete
   *
   * @param uuid
   */
  deleteConfirm = ({ uuid }) => {
    Modal.confirm({
      title: 'Confirmar!',
      content: 'Deseja reabrir este fechamento?',
      okText: 'Sim',
      autoFocusButton: null,
      onOk: () => {
        return this.deleteConfirmed(uuid)
      },
    })
  }

  deleteConfirmed = (uuid) => {
    return closingCalculationPeriodService
      .destroy({ uuid })
      .then((response) => {
        // Fetch all
        this.fetchGetAll()
      })
      .catch((data) => {
        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

 /**
	 * Create
	 */
	createOpen = () => {
		this.setState({ createModalVisible: true });

		// On open screen
		this.createScreen.onOpen();
	};

	createOnClose = () => {
		this.setState({ createModalVisible: false });
	};

	createOnComplete = () => {
		this.setState({ createModalVisible: false });
		// Fetch all
		this.fetchGetAll(true)
	};

  /**
   * Filter
   */
  filtersOpen = () => {
    this.setState({ filtersModalVisible: true })

    // On open screen
    this.filtersScreen.onOpen({ ...this.state.filters })
  }

  filtersOnClose = () => {
    this.setState({ filtersModalVisible: false })
  }

  filtersOnComplete = (filters) => {
    this.setState({ filtersModalVisible: false })
    this.setState(
      {
        filters: filters,
      },
      () => {
        // Fetch all
        this.fetchGetAll(true)
      }
    )
  }

  filtersCount = () => {
    const { empresa, departamento, funcionario } = this.state.filters

    return [empresa, departamento, funcionario].filter(Boolean).length
  }

  render() {
    return (
      <QueueAnim className="site-content-inner">
        <div className="page-content fixed-header closing-calculation-period-page" key="1">
          <UIPageListing
            icon={config.icon}
            title={config.title}
            subtitle={config.subtitle}
            kpis={this.kpis()}
            infoBanner={config.infoBanner}
            appendSearch={(
              <DatePicker.RangePicker
                size="large"
                format="DD/MM/YYYY"
                placeholder={['Data início', 'Data fim']}
                allowEmpty={[true, true]}
                value={this.state.periodo}
                onChange={this.onPeriodoChange}
              />
            )}
            filtersCount={this.filtersCount()}
            enableSearch={false}
            onPaginationChange={this.onPaginationChange}
            onOrderChange={this.onOrderChange}
            onListTypeChange={this.onListTypeChange}
            onFiltersClick={this.filtersOpen}
            isLoading={this.state.isLoading}
            listType={this.state.listType}
            orderByField={this.state.orderByField}
            orderBySort={this.state.orderBySort}
            orders={config.orders}
            data={this.state.data}
            pagination={this.state.pagination}
            columns={this.columns()}
            showFilters={true}
            buttons={[
              {
                visible: this.props.permissions.includes(config.permissionPrefix + ".create") ,
                onClick: this.createOpen,
                title: 'Incluir',
                icon: <i className="far fa-plus" />,
              },
            ]}
          />
        </div>
        <ModalCreate
					ref={el => this.createScreen = el}
					visible={this.state.createModalVisible}
					onComplete={this.createOnComplete}
					onClose={this.createOnClose}
				/>
        <ModalShow
          ref={(el) => (this.showScreen = el)}
          visible={this.state.showModalVisible}
          onClose={this.showOnClose}
        />
        <ModalFilters
          ref={(el) => (this.filtersScreen = el)}
          visible={this.state.filtersModalVisible}
          onComplete={this.filtersOnComplete}
          onClose={this.filtersOnClose}
        />
      </QueueAnim>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.auth.userData.permissions,
    listType: state.general.listType[config.list],
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChangeListType: (type) => {
      dispatch(generalActions.changeListType(config.list, type))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)
